<template>
    <div class="page-user">
        <!-- 个人中心用户卡片 -->
        <user-card/>
        <div class="content">
            <!-- 左菜单 -->
            <el-affix :offset="0" style="margin-right:20px">
                <div class="menu user-menu">
                    <Menu/>
                </div>
            </el-affix>
            <!-- 右内容区 -->
            <div class="main-content">
                <slot></slot>
            </div>
            <!-- <el-backtop :right="20" :bottom="150" class="back-top" style="border-radius:4px">
                <div class="back-icon"></div>
            </el-backtop> -->
        </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue'
import UserCard from './part/user-card.vue'
import Menu from '@/components/menu/menu.vue'

onMounted(() => {
    window.scrollTo(0, 0);
})

</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.page-user{
    width:100%;
    overflow: hidden;
    position: relative;
    .content{
        display: flex;
        margin-top: 20px;
        align-items: flex-start;
        .main-content{
            flex: 1;
        }
    }
    .back-top {
        width: 44px;
        height: 44px;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px rgb(0 0 0 / 12%);
        border-radius: 4px;

        &:hover {
             .back-icon {
                width: 22px;
                height: 22px;
                background: url('~@/assets/img/user-center/back-top-hover.png') 0 0 no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .back-icon {
        width: 22px;
        height: 22px;
        background: url('~@/assets/img/user-center/back-top.png') 0 0 no-repeat;
        background-size: 100% 100%;
    }
    .user-menu {
        overflow-y: auto;
        max-height: calc(100vh - 157px);
        overflow-x: hidden;
    }
}
 
</style>
